module.exports = __webpack_public_path__ + "img/600x100.81e8c8d1.png";